import { Action } from './base/action.model';

export enum AppActionNames {
  STORE_STATE = '[APP] Store State',
  STORE_TOKEN = '[APP] Store Token',
  STORE_INFO_USER = '[APP] Store Info User', 
  STORE_THEME = '[APP] Store Theme', 
  STORE_SOURCE_INFO = '[APP] Store SourceInfo', 
  STORE_LIFE_HERO_SOURCE_INFO = '[APP] Store Life Hero SourceInfo', 
  GET_INFO_USER = '[APP] Get Info User',
  GET_SALE_LIST = '[APP] Get Sale List',
  GET_LIFE_HERO_PRODUCT_LIST = '[APP] Get Life Hero Product List',
  OPEN_OTP = '[APP] Open OTP',
  SET_TIME_OTP = '[APP] Set Time OTP',
  SET_DATA_OTP = '[APP] Set Data OTP',
}
export class StoreState implements Action {
  static readonly type = AppActionNames.STORE_STATE;
  constructor(public payload: any) {}
}
export class StoreToken implements Action {
  static readonly type = AppActionNames.STORE_TOKEN;
  constructor(public payload: any) {}
}
export class StoreInfoUser implements Action {
  static readonly type = AppActionNames.STORE_INFO_USER;
  constructor(public payload: any) {}
}
export class StoreResource implements Action {
  static readonly type = AppActionNames.STORE_SOURCE_INFO;
  constructor() {}
}
export class StoreLifeHeroResource implements Action {
  static readonly type = AppActionNames.STORE_LIFE_HERO_SOURCE_INFO;
  constructor(public payload: any) {}
}
export class GetInfoUser implements Action {
  static readonly type = AppActionNames.GET_INFO_USER;
  constructor() {}
}
export class GetSaleList implements Action {
  static readonly type = AppActionNames.GET_SALE_LIST;
  constructor() {}
}
export class GetLifeHeroProductList implements Action {
  static readonly type = AppActionNames.GET_LIFE_HERO_PRODUCT_LIST;
  constructor() {}
}
